// extracted by mini-css-extract-plugin
export default {"root":"Accordion_root__SyV-r","summary":"Accordion_summary__wRgnz"};